import { jsx as _jsx } from "react/jsx-runtime";
export var ProgressBar = function (_a) {
    var currentStep = _a.currentStep, totalSteps = _a.totalSteps;
    var progressPercentage = ((currentStep - 1) / (totalSteps - 1)) * 100;
    return (_jsx("div", { className: "tiof-progress-bar", children: _jsx("div", { className: "tiof-progress-indicator", style: { width: "".concat(progressPercentage, "%") } }) }));
};
